import { useMemo } from 'react';
import { User } from '../../../@types/users';
import { UserListItem } from './user-list-item';

type UsersListProps = {
  users: User[];
  onUserClick: (user: User) => void;
};

export const UsersList = ({ users, onUserClick }: UsersListProps) => {
  const sortedUsers = useMemo(() => {
    return [...users].sort((a, b) => {
      const aHasUsername = Boolean(a.username);
      const bHasUsername = Boolean(b.username);

      if (aHasUsername !== bHasUsername) {
        return aHasUsername ? -1 : 1;
      }

      const firstNameComparison = a.firstName.localeCompare(b.firstName, 'he');
      if (firstNameComparison !== 0) {
        return firstNameComparison;
      }

      return a.lastName.localeCompare(b.lastName, 'he');
    });
  }, [users]);

  if (sortedUsers.length <= 0) {
    return <div>אין משתמשים להצגה</div>;
  }

  return (
    <>
      {sortedUsers.map((user) => {
        return (
          <UserListItem
            onClick={() => {
              onUserClick(user);
            }}
            key={user.id}
            user={user}
          />
        );
      })}
    </>
  );
};
